/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/reportModel",
], function (Marionette, Backbone, Highcharts, $, Messenger, ReportUtilities) {
  "use strict";

  const PieReportShow = function (report, renderTo, singleReportModule) {
    const clickAction = _clickActionAction(report);

    if (report.type === "pie") {
      let notSpecified = "";
      if (report.options.title === undefined) {
        notSpecified = "\ntitle";
      }
      if (report.options.seriesTitle === undefined) {
        notSpecified = notSpecified + "\nseriesTitle";
      }
      if (notSpecified !== "") {
        Messenger.okDialog(
          "The following report options are required for pie charts, but were not specified:\n" +
            notSpecified +
            "\n\nThey must be added to the report when it is created on the server.  The report will not be able to display until they are added.",
        );
        return;
      }

      let dataSet = Messenger.reqres.request("pieData", report.href);
      console.log(dataSet);
      singleReportModule.listenTo(
        dataSet,
        "sync",
        function () {
          //dataSet.once("sync", function() {
          //show the single report layout
          singleReportModule.showRegion(singleReportModule.layout);
          Messenger.vent.trigger("report:arrived", report);
          console.log(dataSet);
          dataSet = dataSet.toJSON();
          console.log(dataSet);

          //translate it first, then figure out parameters.  can't figure out parameters first b/c then it
          //wouldn't match anything in our translation files.
          let currentTitle = $.t(report.options.title);
          currentTitle = ReportUtilities.figureOutText(currentTitle, true);
          const seriesName = $.t(report.options.seriesTitle);

          let subTitleText = null;
          if (report.options.subTitle) {
            subTitleText = $.t(report.options.subTitle);
          }
          if (subTitleText !== null) {
            subTitleText = ReportUtilities.figureOutText(subTitleText, true);
          }

          //dollar-dot-t the data names.  If it shouldn't be translated, it won't be in key form,
          //so it will stay the same.  If it should (such as "Has Reason"), it will be translated
          for (let i = 0; i < dataSet.length; i++) {
            dataSet[i].name = $.t(dataSet[i].name);
          }

          const checkForData = function (dataSet) {
            return dataSet.length !== 0;
          };

          const hasData = checkForData(dataSet);
          //hasData ? alert(currentTitle + " has Data"):alert(currentTitle + " has No Data");
          if (!hasData) {
            subTitleText = $.t("reports.noData.long");
          }

          $(function () {
            singleReportModule.createChart({
              chart: {
                type: "pie",
              },
              title: {
                text: currentTitle,
              },
              subtitle: {
                text: subTitleText,
              },
              plotOptions: {
                pie: {
                  point: {
                    events: {
                      click: function () {
                        if (clickAction) {
                          clickAction(this.name);
                        }
                      },
                    },
                  },
                },
              },
              series: [
                {
                  name: seriesName,
                  data: dataSet,
                },
              ],
            });
          });
          //TODO: Add click event handler
        },
        this,
      );
    }
  };

  function _clickActionAction(report) {
    let clickAction = null;

    //report-specific stuff
    if (report.href.startsWith("/reasonCode")) {
      clickAction = function (category) {
        /**
         * Parameter setup.  The Escalation Topic report needs to know which channel you want topics for - it's a
         * parameter. So, we need to set a handler for the topic here. Note that this handler isn't cleared explicitly.
         *  Rather, when the report area view is closed (which it is when a new report is shown), this is cleaned up.
         * Although I'm not 100% sure that this will work with multiple drilldown - I'll find that out fairly soon.
         */

        /**
         * The category is going to come here as I18N'ed.  We need a standard format to send it down to the server in,
         * or it will get totally bamboozled as we add new languages.  So, we shall compare the category with the
         * I18N'ed versions of "with" and "without" and send down a fixed string, not an I18N string.
         */
        const urlVersion =
          category === $.t("reports.reasonCode.hasReasonCode") ? "with" : "without";
        Messenger.vent.trigger("set:parameter", "reasonWithOrWithout", urlVersion);
        Messenger.vent.trigger("set:parameter", "reasonWithOrWithoutDisplay", category);
        /**
         * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
         * reportModel).  Here, we retrieve that.
         */
        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.  We
         * also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down to
         * wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            //Trim the whitespace just to be safe
            currentDrillDown.chosenDrillDown = urlVersion.trim();
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    } else if (report.href.startsWith("/examplesPerTopic")) {
      clickAction = function (category) {
        /**
         * Parameter setup.  The Escalation Topic report needs to know which channel you want topics for - it's a
         * parameter. So, we need to set a handler for the topic here. Note that this handler isn't cleared explicitly.
         *  Rather, when the report area view is closed (which it is when a new report is shown), this is cleaned up.
         * Although I'm not 100% sure that this will work with multiple drilldown - I'll find that out fairly soon.
         */

        /**
         * The category is going to come here as I18N'ed.  We need a standard format to send it down to the server in,
         * or it will get totally bamboozled as we add new languages.  So, we shall compare the category with the
         * I18N'ed versions of "with" and "without" and send down a fixed string, not an I18N string.
         */
        let parameter;
        if (category === "1 - 8") {
          parameter = 0;
        } else if (category === "9 - 15") {
          parameter = 1;
        } else if (category === "16 - 25") {
          parameter = 2;
        } else {
          parameter = 3;
        }
        Messenger.vent.trigger("set:parameter", 1, "{exampleBucket}", parameter, category);
        /**
         * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
         * reportModel).  Here, we retrieve that.
         */
        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.  We
         * also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down to
         * wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    }
    //if we're getting here from history, kludge the parameter
    //        if (report.fromHistory)
    //        {
    //          Messenger.vent.trigger("set:parameter", 2, "{touchpoint}", report.reportArguments[2].paramValue);
    //          report.fromHistory = false;
    //        }
    return clickAction;
  }

  return PieReportShow;
});
